// src/pages/auth/VerifyEmail.js
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../../services/api';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verificando');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      setStatus('error');
      setMessage('Token no proporcionado');
      return;
    }

    api.get(`/auth/verify-email/${token}`)
      .then(response => {
        setStatus('exito');
        setMessage(response.data.message);
      })
      .catch(error => {
        setStatus('error');
        setMessage(error.response?.data?.error || 'Error al verificar email');
      });
  }, [searchParams]);

  return (
    <div className="auth-container">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        {status === 'verificando' && (
          <>
            <div className="loading-spinner" style={{ margin: '30px auto' }}></div>
            <h2>Verificando tu email...</h2>
          </>
        )}

        {status === 'exito' && (
          <>
            <div style={{ fontSize: '5rem', marginBottom: '20px' }}>✅</div>
            <h2 style={{ color: '#51cf66' }}>¡Email Verificado!</h2>
            <p>{message}</p>
            <Link to="/login" className="btn btn-primary" style={{ marginTop: '30px' }}>
              Iniciar Sesión
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: '5rem', marginBottom: '20px' }}>❌</div>
            <h2 style={{ color: '#ff6b6b' }}>Error de Verificación</h2>
            <p>{message}</p>
            <Link to="/login" className="btn btn-primary" style={{ marginTop: '30px' }}>
              Volver al Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;